import React from 'react';
/**
 * this is used by comments-ooi-translations-provider to inject translations
 * @internal
 */
export const ExternalTranslationsContext = React.createContext({
    t: (s) => s,
});
//# sourceMappingURL=external-translations-context.js.map